
let DataCounterFactory = function ($translate) {
    var locationHoldcount = null
    var itemHoldcounts = null
    var remainingToPack = null
    var atmCodeData = null
    var allData = null;

    const setCounterForLocationHold = function (data) {
        locationHoldcount = data;
    }

    const getCounterForLocationHold = function () {
        return locationHoldcount
    }

    const setCounterForItemHold = function (data) {
        itemHoldcounts = data;
    }

    const getCounterForItemHold = function () {
        return itemHoldcounts
    }

    const setPendingPackData = function (data) {
        remainingToPack = data;
    }

    const getPendingPackData = function () {
        return remainingToPack
    }

    const setAtmCodeData = function (data) {
        atmCodeData = data;
    }

    const getAtmCodeData = function () {
        return atmCodeData
    }

    const setData = function (data) { // common method for all
        return allData = data;
    }

    const getData = function (data) { // common method for all
        return allData;
    }

    return {
        setCounterForLocationHold,
        getCounterForLocationHold,
        setCounterForItemHold,
        getCounterForItemHold,
        setPendingPackData,
        getPendingPackData,
        setAtmCodeData,
        getAtmCodeData,
        getData,
        setData
    }
}

DataCounterFactory.$inject = ['$translate'];

export default DataCounterFactory;


// WEBPACK FOOTER //
// ./client/app/common/data-counter/datacounter.factory.js